function cargarListaSocios(avisarAbierta){
    $.get('/view/socio/getListaUsuarios/'+avisarAbierta, function (data) {
        $("#lista_usuarios_panel .panel-body").html(data);
        $("#lista_usuarios_panel").removeClass('hidden');
    });
}

$(document).on('change', '.cal_event_content #lista_usuarios [name=lista_usuarios]', function () {
    var radio = $(this);
    if (radio.val() !== '0') {
        cargarListaSocios(radio.val());
    } else {
        $("#lista_usuarios_panel").addClass('hidden');
    }
});

$(document).on('click','#lista_usuarios_panel .confirmaEliminacion',function(){
   var avisarAbierta = $(".listaAnadirUsuario").data('avisar_abierta');
   var idMstSociosSeleccionado = $(this).closest('li').data('id_mst_socios');
    var data = {
        'id_mst_socios2':idMstSociosSeleccionado,
        'avisar_abierta':avisarAbierta
    }
    $.post('/api/socio/ListaUsuarios/eliminaUsuario',data,function(){
        cargarListaSocios(avisarAbierta);
   });
});

$(document).on('click','#collapse_listaNegra',function(){
    cargarListaSocios(1);
});

$(document).on('click', '.selectSocio.listaAnadirUsuario table tr', function () {
    var idMstSociosSeleccionado = $(this).data('id_mst_socios');
    var avisarAbierta = $(".listaAnadirUsuario").data('avisar_abierta');
    var data = {
        'id_mst_socios2':idMstSociosSeleccionado
    }
    $.post('/api/socio/postListaUsuarios/'+avisarAbierta,data, function () {
        cargarListaSocios(avisarAbierta);
        $("#modal_c").modal('toggle');
    });
});

function edit_event_create_inputs_onsave(){
    $("#event-form").find('[name=lista_usuarios]').remove();
    var listaUsuariosValor = $("#lista_usuarios [name=lista_usuarios]:checked").val();
    $("#event-form").append('<input type="hidden" name="lista_usuarios" value="' + listaUsuariosValor + '"/>');
}

$(function(){
   var id_reg_reserva = $('[name=id_reserva]').val();
   if (!(id_reg_reserva>0)){
       $("#lista_usuarios_panel").addClass('hidden');
       return;
   }

   if ($("[name=reserva_opcion_abierta]").val()=='1'){
       $("[name=lista_usuarios][value='1']").prop('checked',true);
       var avisarAbierta = $(".listaAnadirUsuario").data('avisar_abierta');
       cargarListaSocios(avisarAbierta);
   }else{
       $("#lista_usuarios_panel").addClass('hidden');
   }
});